export const INDENT_STEP = 2;
export const MAX_INDENT = 10;
// Lists included — container (bulletList/orderedList) gets indented as a whole, Word-style
export const INDENT_TYPES = ['paragraph', 'heading', 'bulletList', 'orderedList'];
